import {ValueObject} from '@s-ui/domain'

export class VersionSpecificationsValueObject extends ValueObject {
  /**
   * @param {Object} params
   * @param {Number} params.acceleration
   * @param {String} params.autonomy
   * @param {Number} params.axisDistance
   * @param {Number} params.barsDiameter
   * @param {String} params.batteryType
   * @param {String} params.bodyType
   * @param {Number} params.bore
   * @param {String} params.brakeCalipers
   * @param {String} params.chargingTime
   * @param {String} params.chassis
   * @param {String} params.clutch
   * @param {String} params.configuration
   * @param {Number} params.consumptionAverage
   * @param {Number} params.consumptionExtraUrban
   * @param {Number} params.consumptionUrban
   * @param {Number} params.cubicCapacity
   * @param {String} params.cycle
   * @param {Number} params.cylinders
   * @param {String} params.cylindersDisposition
   * @param {Number} params.cylinderValves
   * @param {String} params.distribution
   * @param {Number} params.doors
   * @param {Number} params.emissions
   * @param {Object} params.electricFeatures
   * @param {Number} params.forkAngle
   * @param {String} params.frontBrake
   * @param {String} params.frontBrakeDiameter
   * @param {String} params.frontSuspension
   * @param {String} params.frontSuspensionSetting
   * @param {String} params.frontTyre
   * @param {Number} params.frontWheelTravel
   * @param {Number} params.fuelTankCapacity
   * @param {String} params.fuelType
   * @param {String} params.gearBox
   * @param {Number} params.gears
   * @param {Number} params.height
   * @param {Number} params.hp
   * @param {Number} params.hpRpm
   * @param {Number} params.kw
   * @param {Number} params.length
   * @param {Number} params.luggageCapacity
   * @param {String} params.make
   * @param {Number} params.manufacturerPrice
   * @param {String} params.model
   * @param {Number} params.movementWeight
   * @param {Number} params.pistons
   * @param {Number} params.powerElectric
   * @param {String} params.rearBrake
   * @param {String} params.rearBrakeDiameter
   * @param {String} params.rearSuspension
   * @param {String} params.rearSuspensionSetting
   * @param {String} params.rearTyre
   * @param {Number} params.rearWheelTravel
   * @param {String} params.refrigeration
   * @param {Number} params.seatHeight
   * @param {Number} params.seats
   * @param {String} params.starterSystem
   * @param {Number} params.stroke
   * @param {String} params.supply
   * @param {String} params.swingingArm
   * @param {Number} params.topSpeed
   * @param {Number} params.torque
   * @param {Number} params.torqueRpm
   * @param {String} params.traction
   * @param {Number} params.trail
   * @param {String} params.transmissionType
   * @param {String} params.version
   * @param {Number} params.weight
   * @param {Number} params.width
   * */
}
